import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Admin} from '../admin';
import {Page} from '../../core/pagination/page';
import {PageRequest} from '../../core/pagination/page-request';
import {SortOrder} from '../../core/sort/sort-order';

@Component({
    selector: 'zah-admins',
    templateUrl: './admins.component.html',
    styleUrls: ['./admins.component.scss'],
    standalone: false
})
export class AdminsComponent implements OnInit {

    @Input()
    initialPageRequest: PageRequest<Admin>;
    @Input()
    adminsPage: Page<Admin>;
    @Output()
    adminClicked: EventEmitter<Admin> = new EventEmitter<Admin>();
    @Output()
    deleteClicked: EventEmitter<Admin> = new EventEmitter<Admin>();
    @Output()
    addClicked: EventEmitter<void> = new EventEmitter<void>();
    @Output()
    pageChange: EventEmitter<PageRequest<Admin>> = new EventEmitter<PageRequest<Admin>>();

    private currentPageRequest: PageRequest<Admin>;

    ngOnInit(): void {
        this.currentPageRequest = this.initialPageRequest;
    }

    onAdminClick(admin: Admin): void {
        this.adminClicked.emit(admin);
    }

    onDeleteClick(admin: Admin): void {
        this.deleteClicked.emit(admin);
    }

    onAddClick(): void {
        this.addClicked.emit();
    }

    onSortOrderChange(sortOrder: SortOrder): void {
        this.currentPageRequest = PageRequest.firstPageRequest<Admin>(sortOrder, this.currentPageRequest.getPageSize());
        this.pageChange.emit(this.currentPageRequest);
    }

    onPageSizeChange(pageSize: number): void {
        this.currentPageRequest = PageRequest.firstPageRequest<Admin>(this.currentPageRequest.getSortOrder(), pageSize);
        this.pageChange.emit(this.currentPageRequest);
    }

    onPageChange(pageRequest: PageRequest<Admin>): void {
        this.currentPageRequest = pageRequest;
        this.pageChange.emit(pageRequest);
    }
}
